/*
 * @Author: Kennan.Chen
 * @Date: 2020-03-15 23:14:14
 * @Last Modified by: Kennan.Chen
 * @Last Modified time: 2020-03-22 11:23:49
 */
export default {
  methods: {
    listenEvent(eventName, callback) {
      this.listen(this.$el, eventName, callback)
    },

    listen(el, eventName, callback) {
      el = el || this.$el
      const listener = el.addEventListener(eventName, callback)
      this.$once('hook:beforeDestroy', () => {
        el.removeEventListener(eventName, listener)
      })
    }
  }
}
